"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _d3Geo = require("d3-geo");

var _reactSimpleMaps = require("react-simple-maps");

var _styles = require("@material-ui/styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var styles = {
  root: {
    pointerEvents: "none"
  },
  label: {},
  marker: {},
  annotation: {
    "& path": {
      stroke: "#ccc"
    }
  },
  text: {
    fontSize: 14,
    fontFamily: "sans-serif",
    fill: "#ccc"
  }
};

function GeoJsonLabels(_ref) {
  var _ref$geographies = _ref.geographies,
      geographies = _ref$geographies === void 0 ? [] : _ref$geographies,
      classes = _ref.classes,
      className = _ref.className,
      metadata = _ref.metadata,
      metadataSelector = _ref.metadataSelector,
      _ref$labelSelector = _ref.labelSelector,
      labelSelector = _ref$labelSelector === void 0 ? function (d) {
    return d && d.id;
  } : _ref$labelSelector,
      _ref$offsetSelector = _ref.offsetSelector,
      offsetSelector = _ref$offsetSelector === void 0 ? function (d) {
    return d && d.offset;
  } : _ref$offsetSelector,
      props = _objectWithoutProperties(_ref, ["geographies", "classes", "className", "metadata", "metadataSelector", "labelSelector", "offsetSelector"]);

  return /*#__PURE__*/_react["default"].createElement("g", _extends({
    className: (0, _clsx["default"])("svg-map__labels", classes.root, className)
  }, props), geographies.map(function (geo) {
    var centroid = (0, _d3Geo.geoCentroid)(geo);
    var selector = metadata && metadataSelector && metadataSelector(geo);
    var cur = selector ? metadata.find(selector) : geo;
    var offset = offsetSelector(cur);
    var label = labelSelector(cur);
    var valid = cur && centroid[0] > -160 && centroid[0] < -67;
    return /*#__PURE__*/_react["default"].createElement("g", {
      key: geo.rsmKey + "-name",
      className: (0, _clsx["default"])("svg-map__label", classes.label)
    }, valid && (!offset ? /*#__PURE__*/_react["default"].createElement(_reactSimpleMaps.Marker, {
      className: (0, _clsx["default"])("svg-map__marker", classes.marker),
      coordinates: centroid
    }, /*#__PURE__*/_react["default"].createElement("text", {
      className: (0, _clsx["default"])("svg-map__text", classes.text),
      y: "2",
      textAnchor: "middle"
    }, label)) : /*#__PURE__*/_react["default"].createElement(_reactSimpleMaps.Annotation, {
      subject: centroid,
      dx: offset[0],
      dy: offset[1],
      className: (0, _clsx["default"])("svg-map__annotation", classes.annotation)
    }, /*#__PURE__*/_react["default"].createElement("text", {
      className: (0, _clsx["default"])("svg-map__text", classes.text),
      x: 4,
      alignmentBaseline: "middle"
    }, label))));
  }));
}

GeoJsonLabels.propTypes = {
  geographies: _propTypes["default"].array,
  classes: _propTypes["default"].object,
  className: _propTypes["default"].string,
  metadata: _propTypes["default"].array,
  metadataSelector: _propTypes["default"].func,
  labelSelector: _propTypes["default"].func,
  offsetSelector: _propTypes["default"].func
};

var _default = (0, _styles.withStyles)(styles, {
  name: "HypSvgMapGeoJsonLabels"
})(GeoJsonLabels);

exports["default"] = _default;